import { useTranslation } from 'react-i18next'

import { getInhabitantProfileOptions } from '../../../../../api'
import { useScreen } from '../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { toUserSelectItemsFromOption, UserSelect } from '../../../../User'
import { CONTRACT_FORM_FIELD_NAME_INHABITANT } from '../../../Contract.constants'

function UserField(props) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      {...props}
      Component={FormFieldSelectNG}
      Select={UserSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Contract.UserPlaceholderKey'),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('Contract.UserLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getInhabitantProfileOptions}
      getDataItems={getItemsFromIdwellApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      name={CONTRACT_FORM_FIELD_NAME_INHABITANT}
      toPreparedItems={toUserSelectItemsFromOption}
    />
  )
}

export default UserField
